import { Component, OnInit, ViewChild, Optional, ViewContainerRef } from '@angular/core';
import { AutoTradeCoinConfigService } from '../../_services/autotradecoinconfig.service';
import { Observable } from 'rxjs/Observable';
import { AsyncPipe } from '@angular/common';
import { DialogService } from 'ng2-bootstrap-modal';
import { AutoTradeEditCoinComponent } from './auto-trade-edit-coin/auto-trade-edit-coin.component';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Subject';

@Component({
    selector: 'app-auto-trade-coin-config',
    templateUrl: './auto-trade-coin-config.component.html',
    styleUrls: ['./auto-trade-coin-config.component.css']
})

export class AutoTradeCoinConfigComponent implements OnInit {

    model: any = {};
    pairs: Observable<any[]>;
    dataPairs: any[] = [];
    objectPairs: any = {};
    pairId: string;
    coinName: string;
    delayTimer: any;
    allActive: boolean;
    userActiveTrade: boolean;
    btcBalance: number;

    dtTrigger: Subject<any> = new Subject();
    dtOptions: DataTables.Settings = {};
    @ViewChild(DataTableDirective)
    dtElement: DataTableDirective;

    //declare parameters object
    parameters: any = {};
    //declare callback object
    callback: any = {};

    obj: any;

    constructor(
        private autoTradeCoinConfigService: AutoTradeCoinConfigService,
        private dialogService: DialogService
    ) { }

    ngOnInit() {
        this.registerTable();

        this.pairs = this.autoTradeCoinConfigService.getPairs();

        this.pairs.subscribe(data => {
            this.dataPairs = data;
            data.forEach(element => {
                this.objectPairs[element.id] = element.name;
            });
            this.dtTrigger.next();
        });

        this.autoTradeCoinConfigService.activeStatusOfUser().subscribe(result => {
            this.userActiveTrade = result._body == 1 ? true : false;
        });

    }

    ngAfterViewInit() {
        this.autoTradeCoinConfigService.btcBalance().subscribe(result => {
            this.btcBalance = result._body;
        });
    }

    registerTable() {
        let self = this;
        let btnActiveClass: string;
        var jsonColumn = [
            {
                title: "コイン名",
                data: "coin_name",
                name: "coin_name",
                className: "all text-center"
            },
            {
                title: "コイン市場名",
                data: "cryptocurrency",
                name: "cryptocurrency",
                render: function (pairId) {
                    return self.objectPairs[pairId];
                },
                className: "all text-center"
            },
            {
                title: "数量",
                data: "amount",
                name: "amount",
                className: "text-center"
            },
            {
                title: "ストップロス",
                data: "stop_loss",
                name: "stop_loss",
                className: "text-center"
            },
            // {
            //     title: "",
            //     data: function (d) {
            //         return `<button class="btn btn-sm btn-edit">編集</button>`;
            //     },
            //     width: '60px',
            //     className: "all text-center",
            //     orderable: false
            // },
            {
                title: '<button class="btn btn-sm btn-active-all">全有効</button>',
                data: "btn_is_active",
                width: '60px',
                className: "all text-center",
                orderable: false
            },
        ];

        this.dtOptions = {
            language: {
                emptyTable: "データが存在しません"
            },
            order: [[0, "desc"]],
            searching: false,
            lengthChange: false,
            serverSide: true,
            pageLength: 15,
            ajax: function (parameters, callback, settings) {
                parameters["search"]["value"] = self.coinName || '';

                //assign parameters object
                self.parameters = parameters;

                //assign callback object
                self.callback = callback;

                self.autoTradeCoinConfigService.gets(parameters).subscribe(result => {
                    callback({
                        draw: parameters['draw'],
                        data: result.data,
                        recordsTotal: result.data.length,
                        recordsFiltered: result.recordsTotal,
                    });
                });
            },
            columns: jsonColumn,
            rowCallback: (row: Node, data: any[] | Object, index: number) => {

                const self = this;

                $('.btn-edit', row).bind('click', () => {
                    self.openEdit(data);
                });

                var btn_edit = $(row).find('td').find('.btn-edit');

                btn_edit.css({
                    'background-color': 'deepskyblue',
                    'color': '#fff'
                });

                btn_edit.mouseover(function () {
                    btn_edit.css('opacity', '0.9');
                });

                btn_edit.mouseout(function () {
                    btn_edit.css('opacity', '1');
                });

                $('.btn-active-trade', row).bind('click', () => {
                    self.active(data);
                });

                if (index == 0) {
                    self.autoTradeCoinConfigService.checkAllActive().subscribe(result => {
                        if (result.isAllActive) {
                            $('.btn-active-all').removeClass('btn-success').addClass('btn-default').html('すべて無効');
                        } else {
                            $('.btn-active-all').removeClass('btn-default').addClass('btn-success').html('全有効');
                        }
                    });
                    let param: any = {};
                    $('.btn-active-all').unbind('click');
                    $('.btn-active-all').bind('click', () => {
                        if ($('.btn-active-all').hasClass('btn-success')) {
                            param['isActive'] = true;
                        } else {
                            param['isActive'] = false;
                        }
                        self.activeAll(param);
                    });
                }

                if (data['active'] != 1) {
                    $(row).css('background-color', '#3c8dbc');

                    var btn_active_trade = $(row).find('td:last').find('.btn-active-trade');

                    btn_active_trade.css({
                        'background-color': 'HotPink',
                        'border-color': 'HotPink'
                    });

                    btn_active_trade.mouseover(function () {
                        btn_active_trade.css('opacity', '0.8');
                    });

                    btn_active_trade.mouseout(function () {
                        btn_active_trade.css('opacity', '1');
                    });
                }
                return row;
            }
        };
    }

    openEdit(data) {
        this.dialogService.addDialog(AutoTradeEditCoinComponent, {
            coinId: data.id,
            pairs: this.dataPairs,
            coinName: data.coin_name,
            pair: data.cryptocurrency,
            amount: data.amount,
            stopLoss: data.stop_loss,
        }).subscribe((isAccess) => {
            if (isAccess) {
                this.loadCurrentPage();
            }
        });
    }

    active(data) {
        this.autoTradeCoinConfigService.active(data).subscribe(data => {
            this.loadCurrentPage();
        });
    }

    activeAll(data) {
        this.autoTradeCoinConfigService.activeAll(data).subscribe(data => {
            this.loadCurrentPage();
        });
    }

    checkAllActive() {
        this.autoTradeCoinConfigService.checkAllActive().subscribe(result => {
            return result.isAllActive;
        });
    }

    changeStatus(event) {
        let model: any = {};
        model['status'] = event.target.checked;
        this.autoTradeCoinConfigService.updateAutoTradeStatus(model).subscribe(
            data => {
                if (data.error == true) {
                    alert(data.message);
                    window.location.reload();
                }
            }
        );
    }

    valuechange(newValue) {
        this.coinName = newValue;
        this.doSearch();
    }

    doSearch() {
        let self = this;
        clearTimeout(this.delayTimer);
        this.delayTimer = setTimeout(function () {
            self.rerenderDataTable();
        }, 600); // Will do the ajax stuff aft
    };

    rerenderDataTable(): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw();
        });
    }

    loadCurrentPage() {
        //get parameters and retrive result of current page 
        this.autoTradeCoinConfigService.gets(this.parameters).subscribe(result => {
            //use callback function
            this.callback({
                //retrive draw current
                draw: this.parameters['draw'],
                //retrive data of current page
                data: result.data,
                //retrive number records per page
                recordsTotal: result.data.length,
                //retrive total records
                recordsFiltered: result.recordsTotal
            });
        });
    }

}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/auto-trade-coin-config/auto-trade-coin-config.component.ts